import InlineBlot from 'quill/blots/inline';
/**
 * Permit to use HOLE tag for the game "Texte a trous"
 * */
class HoleBlot extends InlineBlot {
  static create(): HTMLElement {
    const holeHtmlElement = super.create();
    holeHtmlElement.setAttribute('contenteditable', 'false');
    return holeHtmlElement;
  }
  static formats(): boolean {
    return true;
  }
}

HoleBlot.blotName = 'hole';
HoleBlot.tagName = 'hole';
// Hole.className = 'ql-hole'  // unused but exist

export default HoleBlot;
